<template>
  <div v-if="hospIdShow" class="page flex-col">
    <div class="group_2 flex-col">
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng0a9975edeae4f4a204be7eb6a8a131447a1a41d7e4b38a29d1883ac636da724a.png"/>
      <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
    
      <van-divider :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">预约信息</van-divider>
      <van-tabs v-model:active="active">
        <van-tab title="联系方式">
          <van-form>
            <br />
            <van-cell-group inset>
              <van-notice-bar
                scrollable
                left-icon="volume-o"
                text="请您留意手机来电，以便我们可以及时联系到您！"/>
              <van-field
                v-model="registerData.realName"
                required
                label="您的称呼"
                :rules="[{ required: true, message: '请填写您的称谓' }]"/>
              <van-field
                v-model="registerData.phone"
                required
                label="手机号码"
                :rules="[
                  { required: true },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '手机号码格式错误！',
                  },
                ]"/>
            </van-cell-group>
          </van-form>
          <van-divider
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">相关协议签署</van-divider>
          <van-checkbox v-model="registerData.informed">同意并签署如下协议：</van-checkbox>
          <p class="textIndentation">
            <router-link to="/userServiceAgreement">《用户服务协议》</router-link>
            <router-link to="/privacyAgreement">、《隐私服务协议》</router-link>
          </p>
          <div style="margin: 16px">
            <van-button
              v-if="buttonShow"
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              disabled
              native-type="submit"
              @click="getData"
              >{{ submitContext }}</van-button
            >
            <van-button
              v-else
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getData"
              >{{ submitContext }}</van-button
            >
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
  <div v-else class="page flex-col">
    <div class="group_2 flex-col">
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng0a9975edeae4f4a204be7eb6a8a131447a1a41d7e4b38a29d1883ac636da724a.png"/>
      <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
      <span class="text_4">预约须知</span>
      <div class="group_3 flex-col">
        <div class="text-group_2 flex-col">
          <van-form>
            <p class="text2Indentation">
              我们会通过的您的预约信息，进一步沟通情况。请您留意手机来电。
          </p>
          <p class="text2Indentation">
              请您务必保证信息的完整、准确。预约并非下单。
          </p>
          </van-form>
          <van-divider
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">相关协议签署</van-divider>
          <van-checkbox v-model="informedRes">同意并签署如下协议：</van-checkbox>
          <p class="textIndentation">
            <router-link to="/userServiceAgreement">《用户服务协议》</router-link>
            <router-link to="/privacyAgreement">、《隐私服务协议》</router-link>
          </p>
          <div style="margin: 8px">
            <van-button
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getNewData">下一步</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-popup
        v-model:show="showStep"
        round
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '10%' }">
        <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
          {{ popupTx }}
        </van-notice-bar>
      </van-popup>
  <van-overlay :show="showOverlay" @click="showOverlay = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar
            wrapable
            :scrollable="false"
            text="服务提醒"
            left-icon="info-o"/>
          <p class="textIndentation">
            <van-notice-bar
              wrapable
              :scrollable="false"
              color="#1989fa"
              background="#ffffff"
              >{{ bingingNotice }}</van-notice-bar>
          </p>
          <van-button
            v-if="goToUserInfo"
            type="warning"
            block
            plain
            hairline
            @click="showOverlay = false"
          >
            关闭
          </van-button>
          <van-button
            v-if="goToAbout"
            type="warning"
            block
            plain
            hairline
            to="about"
          >
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import {getUserInit} from "../../api/register";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  setup() {
    const active = ref(0);
    const informedRes=ref(false);
    const hospIdShow = ref(false);
    const submitContext = ref("提交申请");
    const showOverlay = ref(false);
    const goToAbout = ref(false);
    const goToUserInfo = ref(false);
    const bingingNotice = ref("");
    const buttonShow = ref(false);
    const doctorButton = ref(false);
    const router = useRouter();
    const kpianawait = reactive({
      cellGroupBackground: "#F1F1F1",
    });
    const state = reactive({
      registerData: {
        realName: "",
        phone: "",
        informed: "",
      },
    });
    const hosp = reactive({
      HospInfo: {
        hospId: "",
      },
    });
    const getNewData = () => {
      console.log(informedRes.value);
      if (informedRes.value) {
        router.push('bindingStepHosp');
      } else{
        showDialog({
            title: "错误提醒",
            message: "您需要先签署相关协议!",
            theme: "round-button",
          }).then(() => {
            
          });
      }
    };
    onMounted(() => {
      console.log("页面打开");
        getUserInit().then((res2) => {
            state.registerData = res2.data.data;
            if (state.registerData.phone != null) {
              console.log(state.registerData);
              submitContext.value = "已确认";
              buttonShow.value = true;
              hospIdShow.value =true;
            }
            console.log(state.registerData);
          });
    });
    return {
      hosp,
      kpianawait,
      ...toRefs(state),
      getNewData,
      active,
      submitContext,
      goToAbout,
      bingingNotice,
      showOverlay,
      buttonShow,
      doctorButton,
      goToUserInfo,
      hospIdShow,
      informedRes,
    };
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
